import {
  UPDATE_FAVORITES,
  UPDATE_RECENTLY_VIEWED_CARDS,
  TOGGLE_FAVORITE_CURATED_COLLECTION,
} from 'js/store/user/User.actions.js';
import { CREATE_COLLECTION, DELETE_COLLECTION } from 'js/store/collections/Collections.actions.js';

const initState = {
  favorites: [],
  favoriteCuratedCollections: [],
  collectionIds: [],
  recentlyViewedCards: [],
};

const user = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case UPDATE_RECENTLY_VIEWED_CARDS: {
      const filteredCards = (state?.recentlyViewedCards || []).filter((id) => id !== action.payload);
      nextState.recentlyViewedCards = [action.payload, ...filteredCards].slice(0, 20);

      return { ...state, ...nextState };
    }
    case UPDATE_FAVORITES: {
      if (state.favorites.includes(action.payload)) {
        nextState.favorites = (state?.favorites || []).filter((favId) => favId !== action.payload);
        return { ...state, ...nextState };
      }

      nextState.favorites = [...state.favorites, action.payload];
      return { ...state, ...nextState };
    }

    case TOGGLE_FAVORITE_CURATED_COLLECTION: {
      const { collectionId } = action.payload;
      if (state.favoriteCuratedCollections.includes(collectionId)) {
        nextState.favoriteCuratedCollections = (state?.favoriteCuratedCollections || []).filter(
          (favId) => favId !== collectionId
        );
        return { ...state, ...nextState };
      }

      nextState.favoriteCuratedCollections = [...state.favoriteCuratedCollections, collectionId];
      return { ...state, ...nextState };
    }

    case CREATE_COLLECTION: {
      nextState.collectionIds = [...(state?.collectionIds || []), action.payload.id];
      return { ...state, ...nextState };
    }

    case DELETE_COLLECTION: {
      nextState.collectionIds = state.collectionIds.filter((id) => id !== action.payload.id);
      return { ...state, ...nextState };
    }

    default:
      break;
  }
  return state;
};

export default user;
